import { render } from "./address_upload.vue?vue&type=template&id=d9685894&scoped=true"
import script from "./address_upload.vue?vue&type=script&lang=js"
export * from "./address_upload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9685894"]])

export default __exports__